const __default__ = {
  name: "MessageDetail",

  data() {
    return {
      message: [],
      enquete: [],
      message_detail: {
        message: {
          message_scheduled_for: "",
          call_scheduled_for: ""
        },
        content: {},
        enquete: {
          implement_to: ""
        },
        enquete_contents: {}
      },
      getS3UrlStatus: "内容を確認",
      getS3UrlStatusRunning: false,
      message_targets_count: 0,
      message_targets_students_count: 0,
      message_targets_participants_count: 0,
      message_call_setting: "",
      isLoading: true,
      showConfirmModal: false
    };
  },

  head: {
    title: function () {
      return {
        inner: "お知らせ配信履歴詳細"
      };
    }
  },
  computed: { ...mapState(["studentAddress"])
  },

  created() {
    this.setData();
  },

  methods: {
    setData() {
      getData("reader/get_message_detail/" + this.$route.params.id).then(data => {
        this.message_detail = data.items;
        this.message_targets_count = data.items.targets.students.length + data.items.targets.participants.length;
        this.message_targets_students_count = data.items.targets.students.length;
        this.message_targets_participants_count = data.items.targets.participants.length;
        this.message_detail.message.message_scheduled_for = moment(this.message_detail.message.message_scheduled_for).format("YYYY年MM月DD日(ddd) HH:mm");
        this.message_detail.message.call_scheduled_for = moment(this.message_detail.message.call_scheduled_for).format("YYYY年MM月DD日(ddd) HH:mm");

        if (this.message_detail.enquete) {
          this.message_detail.enquete.implement_to = this.message_detail.enquete ? moment(this.message_detail.enquete.implement_to).format("YYYY年MM月DD日(ddd) HH:mm") : null;
        }

        let call_settings = JSON.parse(this.message_detail.message.settings);
        console.log(call_settings);

        if (call_settings.auto_redial.use === true) {
          this.message_call_setting = call_settings.auto_redial.interval + "分毎に最大" + call_settings.auto_redial.iteration + "回";
        } else {
          this.message_call_setting = "なし";
        }
      }).catch(error => {
        console.log(error); // axiosのresponseが存在するエラーの時は一覧に戻る
        // if (error.response) {
        //   this.$router.push({ name: "messages" });
        // }
      }).then(() => {
        this.isLoading = false;
      });
    },

    getS3SignedUrl() {
      this.getS3UrlStatus = "お待ち下さい";
      this.getS3UrlStatusRunning = true; //secure browserのpopup block 対策

      let newWindow = window.open();
      getData("reader/get_s3_signed_url?path=" + encodeURIComponent(this.message_detail.message.attached_file)).then(data => {
        newWindow.location = data.items.s3url;
      }).catch(error => {
        console.log(error);
      }).then(() => {
        this.getS3UrlStatus = "内容を確認";
        this.getS3UrlStatusRunning = false;
      });
    },

    async switchVisibility(input) {
      try {
        await updateData("messages/settings/" + this.$route.params.id, {
          visibility: input
        });
        this.setData();
      } catch (error) {
        console.log(error);
      }
    },

    showDisableConfirm() {
      this.showConfirmModal = true;
    },

    hideDisableConfirm() {
      this.showConfirmModal = false;
    },

    async executeDisableMessage() {
      this.showConfirmModal = false;

      try {
        await updateData("messages/expire/" + this.$route.params.id, {});
        this.setData();
      } catch (error) {
        console.log(error);
      }
    },

    async disableMessage() {
      try {
        await updateData("messages/expire/" + this.$route.params.id, {});
        this.setData();
      } catch (error) {
        console.log(error);
      }
    }

  }
};
import moment from "moment";
import { getData, updateData } from "@/services/axios";
import LoadingMessage from "@/components/common/LoadingMessage";
import UrlToLink from "@/components/common/UrlToLink.vue";
import RowItem from "../RowItem";
import ConfirmModal from "@/components/common/ConfirmModal.vue";
import { mapState } from "vuex";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    return {
      __sfc: true,
      moment,
      LoadingMessage,
      UrlToLink,
      RowItem,
      ConfirmModal
    };
  }

});